import { tr } from "../i18n";

/**
 * The product categories, in one place.
 *
 * These must match the CHECK constraint on products.category. They were
 * duplicated in the product form and the products filter, and both had fallen
 * three categories behind the database — so an owner could not add a puff bar,
 * which is one of the things these shops sell most of.
 *
 * Labels are read in the device's language each time they are shown.
 */
const VALUES = [
  "juice",
  "puff",
  "device",
  "kit",
  "pod",
  "coil",
  "cotton",
  "accessory",
];

export const categoryLabel = (value) => {
  const key = `common.categories.${value}`;
  const label = tr(key);
  return label === key ? value : label;
};

export const PRODUCT_CATEGORIES = VALUES.map((value) => ({
  value,
  get label() {
    return categoryLabel(value);
  },
}));
